import Swiper from "swiper/js/swiper";

var reviewImagesInstances = [];
var reviewImagesInstanceCounter = 0;

// Font Awesome 6 free solid paths, inlined because the web app does not load Font Awesome.
var reviewImagesIcons = {
    xmark: {
        viewBox: '0 0 384 512',
        path: 'M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5' +
            '-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 ' +
            '45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z'
    },
    chevronLeft: {
        viewBox: '0 0 320 512',
        path: 'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3' +
            'L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'
    },
    chevronRight: {
        viewBox: '0 0 320 512',
        path: 'M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3' +
            'L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'
    }
};

$(document).ready(function () {
    $('.review-images').each(function () {
        initReviewImages($(this));
    });

    $(document).on('click', '.review-images .review-images-img', function (e) {
        e.preventDefault();
        const slide = $(this).closest('.review-images-slide');
        const carousel = slide.closest('.review-images');

        if (slide.length === 0 || carousel.length === 0) {
            return;
        }

        const images = collectReviewImages(carousel);
        const clickedIndex = parseInt(slide.attr('data-image-index'), 10);
        let startIndex = images.findIndex(function (image) {
            return image.index === clickedIndex;
        });

        if (startIndex < 0) {
            startIndex = 0;
        }

        if (images.length > 0) {
            openReviewImagesPopup(images, startIndex, carousel);
        }
    });
});

// slidesPerGroup mirrors slidesPerView so the arrows move a full page instead of one image.
function reviewImagesPage(slidesToShow, slidesPerView) {
    const slides = Math.min(slidesToShow, slidesPerView);

    return { slidesPerView: slides, slidesPerGroup: slides };
}

function initReviewImages(el) {
    if (el.data('swiper-initialized')) {
        return;
    }
    el.data('swiper-initialized', true);

    const slidesToShow = parseInt(el.data('slides-to-show'), 10) || 5;
    const autoplay = String(el.data('autoplay')) !== 'false';
    const autoplaySpeed = parseInt(el.data('autoplay-speed'), 10) || 5000;

    const index = reviewImagesInstanceCounter++;
    const instanceClass = 'review-images-instance-' + index;
    const prevClass = 'review-images-prev-' + index;
    const nextClass = 'review-images-next-' + index;

    const container = el.find('.swiper-container').first();
    container.addClass(instanceClass);
    el.find('.review-images-prev').addClass(prevClass);
    el.find('.review-images-next').addClass(nextClass);

    const options = Object.assign({
        loop: false,
        spaceBetween: 0,
        watchOverflow: true,
        navigation: {
            prevEl: '.' + prevClass,
            nextEl: '.' + nextClass
        },
        breakpoints: {
            480: reviewImagesPage(slidesToShow, 2),
            768: reviewImagesPage(slidesToShow, 4),
            992: reviewImagesPage(slidesToShow, 5)
        }
    }, reviewImagesPage(slidesToShow, 2));

    if (autoplay) {
        options.autoplay = {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        };
    }

    const swiper = new Swiper('.' + instanceClass, options);
    el.addClass('review-images-ready');
    swiper.update();

    if (autoplay && swiper.autoplay) {
        container.on('mouseenter', function () {
            if (swiper.autoplay && swiper.autoplay.running) {
                swiper.autoplay.stop();
            }
        });
        container.on('mouseleave', function () {
            if (swiper.autoplay && !swiper.autoplay.running) {
                swiper.autoplay.start();
            }
        });
    }

    reviewImagesInstances.push(swiper);
}

function collectReviewImages(carousel) {
    const seen = new Set();
    const images = [];

    carousel.find('.review-images-slide').not('.swiper-slide-duplicate').each(function () {
        const slide = $(this);
        const index = parseInt(slide.attr('data-image-index'), 10);

        if (Number.isNaN(index) || seen.has(index)) {
            return;
        }
        seen.add(index);

        images.push({
            index: index,
            url: slide.attr('data-image-url'),
            date: slide.attr('data-image-date') || ''
        });
    });

    images.sort(function (a, b) { return a.index - b.index; });
    return images;
}

// Number of thumbnails on screen, also for the 'auto' slidesPerView used by the horizontal strip.
function visibleThumbCount(swiper) {
    const slidesPerView = Number(swiper.params.slidesPerView);

    if (slidesPerView > 0) {
        return Math.ceil(slidesPerView);
    }

    const first = swiper.slides[0];

    if (!first) {
        return 1;
    }

    const slideSize = (swiper.params.direction === 'vertical' ? first.offsetHeight : first.offsetWidth) +
        (swiper.params.spaceBetween || 0);

    return slideSize > 0 ? Math.max(1, Math.floor(swiper.size / slideSize)) : 1;
}

function reviewImagesIconSvg(icon, cssClass) {
    return '<svg class="' + cssClass + '" xmlns="http://www.w3.org/2000/svg" viewBox="' + icon.viewBox + '" ' +
        'aria-hidden="true" focusable="false">' +
        '<path fill="currentColor" d="' + icon.path + '"/>' +
        '</svg>';
}

function reviewImagesCloseButton(label) {
    return '<button type="button" class="close-review-images-popup" data-dismiss="modal" ' +
        'aria-label="' + label + '">' +
        reviewImagesIconSvg(reviewImagesIcons.xmark, 'close-x-popup') + label +
        '</button>';
}

function openReviewImagesPopup(images, startIndex, carousel) {
    if ($('#review-images-popup').length) {
        $('#review-images-popup').remove();
    }

    const closeLabel = scapeReviewImageHtml(
        (carousel && carousel.data('closeButton'))
        || $('.review-images[data-close-button]').first().data('closeButton')
        || ''
    );

    const safeStartIndex = Math.max(0, Math.min(startIndex, images.length - 1));

    const slidesHtml = images.map(function (image) {
        return '<div class="swiper-slide review-image-popup-slide">' +
            '<img src="' + scapeReviewImageHtml(image.url) + '" class="review-image-popup-img" alt=""/>' +
            '</div>';
    }).join('');

    const thumbnailsHtml = images.map(function (image) {
        return '<div class="swiper-slide">' +
            '<div class="review-image-popup-thumbnail">' +
            '<img src="' + scapeReviewImageHtml(image.url) + '" alt=""/>' +
            '</div>' +
            '</div>';
    }).join('');

    const hasMultipleImages = images.length > 1;

    const modal = $(
        '<div id="review-images-popup" class="modal fade popup-carousel review-images-popup" tabindex="-1">' +
        '<div class="modal-dialog">' +
        '<div class="modal-content">' +
        '<div class="review-images-popup-header">' + reviewImagesCloseButton(closeLabel) + '</div>' +
        '<div class="review-images-popup-close">' + reviewImagesCloseButton(closeLabel) + '</div>' +
        '<div class="modal-body">' +
        '<div class="review-images-popup-layout' + (hasMultipleImages ? ' has-thumbnails' : '') + '">' +
        '<div class="swiper-container review-images-popup-main">' +
        '<div class="swiper-wrapper">' + slidesHtml + '</div>' +
        (hasMultipleImages
            ? '<div class="swiper-button-prev review-images-popup-prev">' +
            reviewImagesIconSvg(reviewImagesIcons.chevronLeft, 'review-images-popup-chevron') +
            '</div>' +
            '<div class="swiper-button-next review-images-popup-next">' +
            reviewImagesIconSvg(reviewImagesIcons.chevronRight, 'review-images-popup-chevron') +
            '</div>'
            : '') +
        '</div>' +
        (hasMultipleImages
            ? '<div class="swiper-container review-images-popup-thumbnails">' +
            '<div class="swiper-wrapper">' + thumbnailsHtml + '</div>' +
            '</div>'
            : '') +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>'
    );
    modal.modal();

    modal.one('shown.bs.modal', function () {
        const isVerticalThumbs = window.matchMedia('(min-width: 768px)').matches;
        const popup = modal[0];
        const thumbsEl = popup.querySelector('.review-images-popup-thumbnails');
        const mainEl = popup.querySelector('.review-images-popup-main');
        let thumbsSwiper = null;

        function setActiveThumb(index) {
            if (!thumbsSwiper) {
                return;
            }

            thumbsSwiper.slides.removeClass('swiper-slide-thumb-active');
            if (thumbsSwiper.slides[index]) {
                $(thumbsSwiper.slides[index]).addClass('swiper-slide-thumb-active');
            }

            const slidesPerView = visibleThumbCount(thumbsSwiper);
            const current = thumbsSwiper.activeIndex || 0;
            const maxStart = Math.max(0, thumbsSwiper.slides.length - slidesPerView);
            let target = current;

            if (index < current) {
                target = index;
            } else if (index >= current + slidesPerView) {
                target = index - slidesPerView + 1;
            }

            thumbsSwiper.slideTo(Math.max(0, Math.min(target, maxStart)), 0);
        }

        if (hasMultipleImages && thumbsEl) {
            thumbsSwiper = new Swiper(thumbsEl, {
                direction: isVerticalThumbs ? 'vertical' : 'horizontal',
                // Horizontal thumbs have a fixed size in CSS, like the product page popup.
                slidesPerView: isVerticalThumbs ? 10 : 'auto',
                slidesPerGroup: 1,
                spaceBetween: isVerticalThumbs ? 8 : 10,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                centerInsufficientSlides: true,
                slideToClickedSlide: true,
                initialSlide: safeStartIndex,
                on: {
                    tap: function (event) {
                        const clickedIndex = this.clickedIndex;
                        if (typeof clickedIndex === 'number' && mainSwiper) {
                            mainSwiper.slideTo(clickedIndex);
                        }
                    }
                }
            });
        }

        var mainSwiper = new Swiper(mainEl, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            initialSlide: safeStartIndex,
            watchOverflow: true,
            navigation: hasMultipleImages
                ? {
                    prevEl: popup.querySelector('.review-images-popup-prev'),
                    nextEl: popup.querySelector('.review-images-popup-next')
                }
                : undefined,
            on: {
                init: function () {
                    setActiveThumb(this.realIndex);
                },
                slideChange: function () {
                    setActiveThumb(this.realIndex);
                }
            }
        });

        setActiveThumb(safeStartIndex);
        if (safeStartIndex !== mainSwiper.activeIndex) {
            mainSwiper.slideTo(safeStartIndex, 0);
        }
        requestAnimationFrame(function () {
            setActiveThumb(mainSwiper.realIndex);
        });
    });

    modal.on('hidden.bs.modal', function () {
        $(this).remove();
    });
}

function scapeReviewImageHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

